import { render, staticRenderFns } from "./EditUniversityPage.vue?vue&type=template&id=17edb66e&scoped=true&"
import script from "./EditUniversityPage.vue?vue&type=script&lang=js&"
export * from "./EditUniversityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17edb66e",
  null
  
)

export default component.exports